<!-- // banner section \\ -->
<section class="banner-section">
    <img class="img-responsive" src="../../../assets/images/about-us-bg.jpg" alt="about-us-banner" />
    <div class="comman-width">         
        <div class="over">
            <h2>How it works</h2>        
            <p>Need Assistance?  We are here to help. Any time of day, all 7 days a week, our<br/> support is here for you.</p>        
        </div>
    </div>
</section>
<!-- \\ banner section // -->  
    
<!-- // card section \\ -->
<section class="card-section">
    <div class="comman-width">         
        <h3>How {{ brandName }} Card works for you</h3>
        <h2>Big companies are often able to provide prescription assistance to their employees by negotiating a discounted rate with pharmacies and insurance carriers.</h2>
        <p>Because they have a large number of employees, these companies are, in essence, buying in bulk. When you become an {{ brandName }} cardholder, you also have access to reduced prices through bulk buying.</p>
        <p>On behalf of consumers nationwide, {{ brandName }} has negotiated a discount rate with a national network of drugstores and retail outlets. Approximately 35,000 pharmacies have partnered with {{ brandName }} to offer prescription assistance to the uninsured and under-insured. Stores benefit in several ways:</p>
        <ul>
            <li>{{ brandName }} steers increased traffic to the store</li>
            <li>Cardholders fill more prescriptions because of the savings</li>
            <li>Increased sales as people browse through the store while filling their prescription</li>
        </ul>        
    </div>
</section>
<!-- \\ card section // -->  
<!-- <section class="card-section test">
    <app-getcard></app-getcard>
</section> -->
 
<!-- // save section \\ -->
<section class="save-section">
    <div class="comman-width">         

        <div class="row">            
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <img class="img-responsive" src="../../../assets/images/how-much-will-i-save.png" alt="how-much-will-i-save" />        
            </div>
            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">        
                <div class="left-gap">
                    <h2>How much will I save with my card</h2>
                    <p>The actual amount you will save varies depending on which pharmacy you use and which medication you buy. Use the prescription price lookup feature to get an idea of what your medicine will cost at different pharmacies. The best way, however, to find out how much you will save is to visit the pharmacy, show them your prescription and Rx discount card and ask what your savings will be. It is always a win-win situation:</p>
                    <ul>
                        <li>The average savings is $61 per prescription.</li>
                        <li>Free for anyone to use.</li>
                        <li>No personal information collected.</li>
                        <li>At least 80 percent of the time your discount card will save you money because the cost will be less than the pharmacy’s retail price.</li>
                    </ul>        
                    <p>If you are struggling and need prescription assistance, {{ brandName }} helps you get the medicine you need. One thing you can be sure of: you will always get the lowest price when you use {{ brandName }}’ Rx discount card.</p>        
                </div>
            </div>       
        </div>

    </div>
</section>
<!-- \\ save section // -->  

<!-- // welcome section \\ -->
<section class="welcome-section edit">
    <div class="comman-width">         
        
        <div class="welcome-center"> 

            <app-search></app-search>

            <div class="search">
                <ul>
                    <li>
                        <div class="image">
                            <img src="../assets/images/behalf-icon1.png" />
                        </div>
                        <span>Search for the best price<br/>&nbsp;</span>    
                    </li>                
                    <li>
                        <div class="image">
                            <img src="../assets/images/behalf-icon2.png" />
                        </div>
                        <!-- <span>Get your card<br/>&nbsp;</span>     -->
                    </li>                
                    <li>
                        <div class="image">
                            <img src="../assets/images/behalf-icon3.png" />
                        </div>
                        <span>Show pharmacist at time of purchase</span>    
                    </li>                
                </ul>
            </div>                        

        </div>

    </div>
</section>
<!-- \\ welcome section // --> 

<!-- // work section \\ -->
<section class="work-section">

    <h2>How does it work?</h2>

    <p>On behalf of consumers nationwide, {{ brandName }} has negotiated a discount rate with a national network of drugstores and retail outlets. Approximately 35,000 pharmacies have partnered with {{ brandName }} to offer prescription assistance to the uninsured and under-insured.</p>

</section>
<!-- \\ work section // -->    

<!-- // signUp section \\ -->
<section class="signUp-section">
    <div class="comman-width">
        <div class="bg">
            <h2>Sign up Today & Start Saving on Prescription</h2>
            <form>
                <input class="form-control field-one" type="text" value="Full Name" />
                <input class="form-control field-second" type="text" value="Email Address" />
                <!-- <button type="submit" class='btn btn-hover-effect'>
                    <div class='insider'></div>
                    Get Your Card Now
                </button> -->
            </form>            
        </div>
    </div>
</section>
<!-- \\ work section // -->    

<!-- // prescription section \\ -->
<section class="prescription-section">
    <div class="comman-width">
        <div class="bg">

            <h2>Pet Prescription Rx Card</h2>

            <div class="row">
                <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
                    <div class="inner-gap">
                        <h3>At {{ brandName }}, we understand that you want your family to have affordable access to prescription coverage. We also realize that pets are often just as much a part of the family as mom, dad and the kids. That is why we offer a discount pet medication program.</h3>
                        <p>Veterinarians often prescribe our four-legged friends the same medication prescribed to us humans, though the dosage is different. Just as the cost of human prescriptions is trending upward, so is the cost of pet prescriptions.</p>
                        <p>With our free pet Rx card, you now can get pet meds for less. Each time you use your pet card, you will save money; although the exact amount depends on the medication and store, you can save up to 85 percent. Sometimes the retail price is lower than the price negotiated by {{ brandName }}; if that is the case, you pay the lower of the two prices. Either way, you save money!</p>                                
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                    <img src="../assets/images/pet-bg.png" class="img-responsive prescriptionimg-responsive" alt="pet-bg" />
                </div>
            </div>

            <div class="petcard">
                <h4>Using your Free Pet Rx Card</h4>
                <p>Getting pet meds for less through our discount pet medication program is simple and hassle-free. Simply complete the online form and print out your pet Rx card. When you pay for your pet’s prescription, show your card to the cashier and walk away with extra money in your pocket.</p>
                <p>Everyone is eligible to participate in our discount pet medication program. Although the most important thing to remember is that you can get pet meds for less and save up to 85 percent on each prescription, there are also several no’s to keep in mind:</p>                
                <ul>
                    <li>No membership fees</li>
                    <li>No paperwork</li>
                    <li>No wait</li>
                    <li>No restrictions on usage</li>
                    <li>No eligibility requirements</li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- \\ prescription section // -->   

    